{
    "actions": {
        "page": {
            "dom_card": "Carte de domiciliation"
        },
        "row": {
            "update": "Modifier",
            "dom_card": "Carte de domiciliation"
        }
    },
    "filter": {
        "placeholder": {
            "legal_and_business_name": "Filtrer par marchands"
        }
    },
    "keys": {
        "legal_and_business_name": "Marchands"
    },
    "tooltip": {
        "legal_and_business_name": "Vous pouvez rechercher par raison sociale ou par nom commercial du marchand"
    }
}